import { YANDEX_METRIKA_ID } from '../config';

type GoalType = 'click' | 'focus' | 'input' | 'other';

type TourHunterType = 'region' | 'hotels';

export default class YandexTrackingService {
  setTrackingGoal(goal: string, goalType: GoalType, params?: Record<string, unknown>): void {
    if (!window.ym) {
      return;
    }

    if (params) {
      window.ym(YANDEX_METRIKA_ID, 'reachGoal', goal, params);
    } else {
      window.ym(YANDEX_METRIKA_ID, 'reachGoal', goal);
    }

    console.log(`${goalType} ${goal}`);
  }

  bannerThClick(isUserAuth: boolean): void {
    this.bannerThTracking(isUserAuth, 'serp', 'region');
  }

  private bannerThTracking(isUserAuth: boolean, funnelStep: string, tourHunterType: TourHunterType): void {
    this.setTrackingGoal('tourhunter_click', 'click', {
      funnel_step: funnelStep,
      user_authorization: isUserAuth,
      placement_banner: true,
      type_of_tourhunter: tourHunterType,
      add_to_tourhunter: true,
    });
  }
}

const yandexTrackingService = new YandexTrackingService();

export { yandexTrackingService };
